import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { TestSubsection } from "./TestSection";
import { Code2, Zap, GitBranch } from "lucide-react";
import * as tests from "./testDefinitions";

export const AdvancedSection = ({ testResults }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold">Widget, Stress & CI</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <TestSubsection
          icon={Code2}
          iconColor="text-purple-600"
          title="Widget & Embed"
          tests={tests.widgetEmbedTests}
          results={testResults.widgetEmbed}
        />
        
        <TestSubsection
          icon={Zap}
          iconColor="text-yellow-600"
          title="Light Stress Tests"
          tests={tests.stressTestTests}
          results={testResults.stressTest}
        />
        
        <TestSubsection
          icon={GitBranch}
          iconColor="text-cyan-600"
          title="CI/CD Readiness"
          tests={tests.ciReadinessTests}
          results={testResults.ciReadiness}
        />
      </CardContent>
    </Card>
  );
};
